import { Link, NavLink, useParams } from 'react-router-dom'
import saddle_logo from '../../assets/icons/saddleLogo.svg'
import { useUserContext } from '../../context/UserContext'
const Header = () => {
  const { user, onSignOutHandler } = useUserContext()

  const hideGradientColor =
    location.pathname === '/event-management' ||
    location.pathname === '/horse-admin' ||
    location.pathname === '/saddle-admin' ||
    location.pathname === '/orders' ||
    location.pathname === '/admin-dashboard' ||
    location.pathname === '/banner-section' ||
    location.pathname === '/all-orders' ||
    location.pathname === '/all-queries' ||
    location.pathname === '/cactus-orders' ||
    location.pathname === '/saddles/manage'


  return (
    <div className={`${hideGradientColor ? 'hidden' : 'hide_gradient'}`}>
      <div className="flex justify-between items-center h-[100px] w-[90%] mx-auto">
        <NavLink to={`${user ? '/event-management' : '/'}`}>
          <img
            src={saddle_logo}
            alt="logo"
            className="lg:flex md:w-auto md:h-auto w-[170px] h-auto"
          />
        </NavLink>

        {user ? (
          <Link
            onClick={onSignOutHandler}
            className={`nav_links text-[16px] text-[#F7F7F6] hover:cursor-pointer font-medium`}
          >
            Logout
          </Link>
        ) : (
          <Link
            className={`nav_links text-[16px] text-[#F7F7F6] no-underline hover:cursor-pointer font-medium`}
          >
            Help
          </Link>
        )}
      </div>
    </div>
  )
}

export default Header
